import React from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import user from "../images/user1.png";

const Intro = () => {
  return (
    <div
      name="name"
      className="h-screen w-full bg-gradient-to-b from-black via-gray to-gray-800"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row ">
        <div className="flex justify-center flex-col h-full">
          <div className="whitespace-normal">
            <h2 className="text-4xl sm:text-7xl font-bold ">
              I'm a Full Stack Developer
            </h2>
          </div>
          <p className="text-gray-500 py-4 max-w-md">
            As a seasoned Software Engineer, I've honed my skills over the past
            2 years at Star Health. Specializing in Java full stack development,
            I bring expertise in crafting robust and scalable solutions. Let's
            innovate together.
          </p>
          <div>
            <button className="group text-black w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-teal-400 to-teal-500 cursor-pointer">
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
              </span>
            </button>
          </div>
        </div>

        <div>
          <img
            src={user}
            alt="My profile"
            className="rounded-2xl mx-auto md:w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default Intro;
